// Reusable US Letter (landscape) Grove Collaborative packing list (DOSS PO-v4 design); mapped identity.
// Generated by scripts/wms/generate.ts for PHP-423. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomGrovePackingListFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  customerBrandSubtitle: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  shipmentDate: yup.string().nullable().optional(),
  carrier: yup.string().nullable().optional(),
  bolNumber: yup.string().nullable().optional(),
  vendorName: yup.string().nullable().optional(),
  vendorAddress: yup.string().nullable().optional(),
  fcLocation: yup.string().nullable().optional(),
  fcAddress: yup.string().nullable().optional(),
  quantityUom: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        lineNumber: yup.number().nullable().optional(),
        vendorUpc: yup.string().nullable().optional(),
        groveSku: yup.string().nullable().optional(),
        itemDescription: yup.string().nullable().optional(),
        variant: yup.string().nullable().optional(),
        quantity: yup.string().nullable().optional(),
        casePacks: yup.string().nullable().optional(),
        parcelCasePackNumber: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type BiomGrovePackingListFileData = yup.InferType<typeof biomGrovePackingListFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<BiomGrovePackingListFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomGrovePackingListFileMappings: RequiredFileData = {
  customerDisplayName: '307d4fb1-8061-4c76-8332-c9bb10333bfd',
  customerBrandSubtitle: 'a0e99d1a-c50e-4c8d-8f03-ceb36ba880da',
  poNumber: 'ffed453f-b07e-446d-a6d6-28b226667048',
  shipmentDate: 'fa335260-74bc-4cef-9390-775ed9cbc9a4',
  carrier: '7ff4d0bb-5de0-4c27-8a04-4c0d65d5c5c9',
  bolNumber: '67a81275-1b69-4949-bc8e-fa4d188faff5',
  vendorName: 'a1bf8434-ac86-46dd-bb61-0ed23c44d906',
  vendorAddress: 'f3f70131-6351-4b77-a711-3fa70e0d217a',
  fcLocation: '9ede3b25-d74a-409a-8285-a5782bd74d9c',
  fcAddress: 'e0d977c1-a0d6-4592-ab20-b4bea2972895',
  quantityUom: 'd8f7ad5a-9cc7-4213-8f21-43f471e381f6',
  items: [
    {
      lineNumber: null,
      vendorUpc: '33936814-eb22-4e65-b810-8c9aa1038cd9',
      groveSku: 'f7775735-1d3a-4a4e-bd31-e3306c7826fb',
      itemDescription: '1f90e415-39ba-4d6d-8b4b-ab706672fc43',
      variant: '0ac9da80-29ee-41ba-934e-7e88deb9df4a',
      quantity: '2cbb2985-793b-4505-917c-ff14339a3c9f',
      casePacks: '608ac83a-51c6-47a2-9057-0c8996bf58ba',
      parcelCasePackNumber: 'acf2a059-8d24-4688-ba94-131c9468cbdd',
    },
  ],
}
